import { defineComponent as d, openBlock as t, createBlock as s, unref as f, mergeProps as b, createSlots as h, withCtx as l, renderSlot as y, createElementVNode as o, toDisplayString as m, createElementBlock as u, createCommentVNode as k, createVNode as g, resolveDynamicComponent as p } from "vue";
import w from "./ghl-ui.es91.js";
import "./ghl-ui.es169.js";
import C from "./ghl-ui.es170.js";
const B = { class: "n-form-custom-label" }, F = {
  key: 0,
  class: "asterisk"
}, I = { key: 0 }, q = d({
  name: "UIFormItem",
  inheritAttrs: !1
}), x = d({
  ...q,
  props: {
    label: {
      type: String
    },
    path: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: !0
    },
    showFeedback: {
      type: Boolean,
      default: !0
    },
    rule: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Object,
      default: null
    },
    required: Boolean
  },
  setup(e) {
    return (a, S) => (t(), s(f(C), b(a.$attrs, {
      rule: e.rule,
      label: e.label,
      path: e.path,
      "show-label": e.showLabel,
      "show-feedback": e.showFeedback,
      class: { "n-form-has-custom-label": e.tooltip },
      required: e.required
    }), h({
      default: l(() => [
        y(a.$slots, "default")
      ]),
      _: 2
    }, [
      e.tooltip ? {
        name: "label",
        fn: l(() => {
          var n, i, r, c;
          return [
            o("div", B, [
              o("span", null, [
                o("span", null, m(e.label), 1),
                e.required ? (t(), u("span", F, " *")) : k("", !0)
              ]),
              g(w, {
                placement: (n = e.tooltip) == null ? void 0 : n.placement,
                trigger: (i = e.tooltip) == null ? void 0 : i.trigger,
                icon: (r = e.tooltip) == null ? void 0 : r.icon,
                iconClass: (c = e.tooltip) == null ? void 0 : c.iconClass
              }, {
                default: l(() => [
                  typeof e.tooltip.text == "string" ? (t(), u("span", I, m(e.tooltip.text), 1)) : (t(), s(p(e.tooltip.text), { key: 1 }))
                ]),
                _: 1
              }, 8, ["placement", "trigger", "icon", "iconClass"])
            ])
          ];
        }),
        key: "0"
      } : void 0
    ]), 1040, ["rule", "label", "path", "show-label", "show-feedback", "class", "required"]));
  }
}), V = x;
export {
  V as default
};
